var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "el_dialog",
      attrs: {
        "close-on-press-escape": false,
        "custom-class": "layout-dialog",
        title: "カレンダー",
        top: "5vh",
        width: "900px",
        visible: _vm.dialogVisible,
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.close,
      },
    },
    [
      _c("vab-calendar", { ref: "calendar", attrs: { "change-show": false } }, [
        _c("div", { attrs: { slot: "noday" }, slot: "noday" }),
      ]),
      _c(
        "div",
        {
          staticClass: "dialog-footer flex_end mg12",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "div",
            { staticClass: "flex_start flex_center_align" },
            [_c("vab-button", { attrs: { "btn-list": _vm.btnList } })],
            1
          ),
        ]
      ),
      _c("PopupChildren", {
        attrs: {
          visible2: _vm.visibleChildren,
          list: _vm.popChildrenList,
          "visible-children": _vm.visibleChildren,
        },
        on: {
          "update:visibleChildren": function ($event) {
            _vm.visibleChildren = $event
          },
          "update:visible-children": function ($event) {
            _vm.visibleChildren = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }